
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesCreate = Marionette.ItemView.extend({
		template: null,
		form_template: null,
		ui: {
			'form':          '',
			'create_submit': ''
		},
		events: {
			'submit @ui.form':         'getFormData',
			'click @ui.create_submit': 'getFormData'
		},
		onRender: function() {
			if (this.form) {
				this.ui.form.append(this.form.$el);
				this.bindUIElements();
			}
		},
		initialize: function() {
			this.scrollToTop();
			this.league_name = this.getOption('league_name');
			this.league      = this.getOption('league');
			this.rounds      = this.getOption('rounds');
			this.user        = this.getOption('user');

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:create:success', this.leagueCreated);

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
		initTemplate: function() {
			return this.initData().setForm().setModelData().render();
		},
		initData: function() {
			this.rounds.invoke('set', {"selected": false});
			this.round_id = this.rounds.getNextScheduledRoundId();

			this.rounds.get(this.round_id).set({'selected': true});
			this.buy_round_ids = this.rounds.getByeRoundIds();

			return this;
		},
		setForm: function() {
			var round_options = this.rounds.getRoundsOptions();

			this.model.set({
				is_season_end: !_.size(round_options)
			});

			console.log(this.round_id);

			this.form = new Backbone.Form({ template: this.form_template, model: this.league });
			this.form.render().fields.start_round.editor.setOptions(round_options);

			this.form.setValue({
				name:        this.league_name || this.user.get('first_name') + '\'s Comp',
				start_round: this.round_id
			});

			return this;
		},
		setModelData: function() {
			this.model.set({
				rounds: this.rounds.toJSON()
			});

			return this;
		},

		getFormData: function() {
			this.showPreloader();

			this.league.create(this.form.getValue());

			return this;
		},

		leagueCreated: function() {
			this.hidePreloader();
			this.trigger('leagues_create:success', this.league.get('id'));

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));